/* Extras do carrinho novo (nativo, sem app):
   - Brinde automático: entra a R$0 quando o subtotal atinge a meta, sai se cair abaixo.
   - Upsell em lista: botão "Adicionar" com refresh do drawer.
   Config vem dos data-attributes do <cart-drawer> (Configurações do tema → Carrinho). */
(function () {
  var busy = false;
  var timer = null;

  function cfg() {
    var el = document.querySelector('cart-drawer');
    if (!el) return null;
    return {
      enabled: el.dataset.paGiftEnabled === 'true',
      variant: parseInt(el.dataset.paGiftVariant, 10) || 0,
      threshold: (parseFloat(el.dataset.paGiftThreshold) || 0) * 100
    };
  }

  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function refreshDrawer() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var tmp = document.createElement('div');
        if (data['cart-drawer']) {
          tmp.innerHTML = data['cart-drawer'];
          var freshInner = tmp.querySelector('.drawer__inner');
          var curInner = document.querySelector('cart-drawer .drawer__inner');
          if (freshInner && curInner) curInner.innerHTML = freshInner.innerHTML;
          var freshRoot = tmp.querySelector('cart-drawer');
          var curRoot = document.querySelector('cart-drawer');
          if (freshRoot && curRoot) curRoot.classList.toggle('is-empty', freshRoot.classList.contains('is-empty'));
        }
        if (data['cart-icon-bubble']) {
          var bubble = document.getElementById('cart-icon-bubble');
          if (bubble) bubble.innerHTML = new DOMParser()
            .parseFromString(data['cart-icon-bubble'], 'text/html')
            .querySelector('.shopify-section').innerHTML;
        }
      })
      .catch(function () {});
  }

  // Confete quando a barra de progresso completa 🎉
  function paConfetti() {
    var host = document.querySelector('cart-drawer .drawer__inner');
    if (!host) return;
    var c = document.createElement('canvas');
    c.className = 'pa-confetti';
    c.width = host.clientWidth; c.height = host.clientHeight;
    host.appendChild(c);
    var ctx = c.getContext('2d');
    var colors = ['#AD6F7F', '#E9BAC7', '#F3D9E0', '#96586A', '#D9A7B0'];
    var parts = [];
    for (var i = 0; i < 90; i++) {
      parts.push({ x: c.width / 2, y: c.height * 0.22, vx: (Math.random() - 0.5) * 10, vy: Math.random() * -8 - 3, g: 0.28, s: Math.random() * 6 + 4, r: Math.random() * Math.PI, vr: (Math.random() - 0.5) * 0.3, col: colors[i % colors.length], life: 90 + Math.random() * 50 });
    }
    var t = 0;
    (function tick() {
      t++; ctx.clearRect(0, 0, c.width, c.height);
      var alive = false;
      parts.forEach(function (p) {
        if (p.life <= 0) return;
        alive = true; p.life--; p.vy += p.g; p.x += p.vx; p.y += p.vy; p.r += p.vr;
        ctx.save(); ctx.translate(p.x, p.y); ctx.rotate(p.r);
        ctx.globalAlpha = Math.min(p.life / 50, 1);
        ctx.fillStyle = p.col; ctx.fillRect(-p.s / 2, -p.s / 2, p.s, p.s * 0.6);
        ctx.restore();
      });
      if (alive && t < 220) requestAnimationFrame(tick); else c.remove();
    })();
  }
  // Safari iOS às vezes não pinta o width inline após innerHTML swap — reforça via JS
  function paFixProgress() {
    var pr = document.querySelector('cart-drawer .pa-progress');
    if (!pr) return;
    var f = pr.querySelector('.pa-progress__fill');
    var pct = parseFloat(pr.getAttribute('data-pct'));
    if (f && !isNaN(pct)) {
      pct = Math.min(pct, 100);
      f.style.transform = 'scaleX(' + (pct / 100) + ')';
    }
  }
  var paGoalInit = false;
  function paCheckGoal() {
    paFixProgress();
    var el = document.querySelector('cart-drawer .pa-progress');
    if (!el) return;
    var done = el.getAttribute('data-done') === 'true';
    var was = false;
    try { was = sessionStorage.getItem('pa-goal-done') === '1'; } catch (e) {}
    if (done && !was) {
      try { sessionStorage.setItem('pa-goal-done', '1'); } catch (e) {}
      if (paGoalInit) paConfetti();
    }
    if (!done && was) { try { sessionStorage.removeItem('pa-goal-done'); } catch (e) {} }
    paGoalInit = true;
  }

  /* placeholder "Wird hinzugefügt..." — feedback imediato enquanto o
     add do brinde + refresh do drawer rodam (~1-2s). Some sozinho quando o
     refreshDrawer troca o .drawer__inner; o finally é só limpeza de erro. */
  function giftPlaceholderShow() {
    if (document.getElementById('pa-gift-loading')) return;
    var host = document.querySelector('cart-drawer #CartDrawer-CartItems') ||
               document.querySelector('cart-drawer .drawer__inner');
    if (!host) return;
    var el = document.createElement('div');
    el.id = 'pa-gift-loading';
    el.className = 'pa-gift-loading';
    el.textContent = 'Wird hinzugefügt...';
    host.appendChild(el);
  }
  function giftPlaceholderHide() {
    var el = document.getElementById('pa-gift-loading');
    if (el) el.remove();
  }

  function reconcileGift() {
    if (busy) { schedule(); return; }
    busy = true;
    var c = cfg();
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var chain = Promise.resolve();

        // 1) brinde automático
        if (c && c.enabled && c.variant && c.threshold) {
          var gift = cart.items.filter(function (i) { return i.variant_id === c.variant; });
          var sub = 0;
          cart.items.forEach(function (i) { if (i.variant_id !== c.variant) sub += i.final_line_price; });
          var qualifies = sub >= c.threshold;
          if (qualifies && gift.length === 0) {
            giftPlaceholderShow();
            chain = postJSON('/cart/add.js', { items: [{ id: c.variant, quantity: 1 }] });
          } else if (!qualifies && gift.length > 0) {
            chain = postJSON('/cart/change.js', { id: gift[0].key, quantity: 0 });
          } else if (gift.length > 0 && gift[0].quantity !== 1) {
            chain = postJSON('/cart/change.js', { id: gift[0].key, quantity: 1 });
          }
        }

        // (Livéa: descontos por quantidade são AUTOMÁTICOS nativos — 2ER-SET/3ER-SET — nada a aplicar via cupom.)
        return chain.then(refreshDrawer).then(paCheckGoal);
      })
      .catch(function () {})
      .finally(function () { busy = false; giftPlaceholderHide(); });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(reconcileGift, 400);
  }

  // Reage a qualquer mutação do carrinho (tema, upsell, kit, PDP…)
  var origFetch = window.fetch;
  window.fetch = function () {
    var url = arguments[0];
    if (url && typeof url === 'object' && url.url) url = url.url;
    var p = origFetch.apply(this, arguments);
    try {
      if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) {
        p.then(function (r) { schedule(); return r; }, function () { schedule(); });
      }
    } catch (e) {}
    return p;
  };

  // Ignora "cliques" que na verdade foram deslizes (toque que se moveu >10px)
  var paTouchX = 0, paTouchY = 0, paTouchMoved = false;
  document.addEventListener('touchstart', function (e) {
    var t = e.touches[0]; paTouchX = t.clientX; paTouchY = t.clientY; paTouchMoved = false;
  }, { passive: true });
  document.addEventListener('touchmove', function (e) {
    var t = e.touches[0];
    if (Math.abs(t.clientX - paTouchX) > 6 || Math.abs(t.clientY - paTouchY) > 6) paTouchMoved = true;
  }, { passive: true });

  // Bloqueia cliques logo após rolagem dentro do drawer (toque-arrasto no iOS)
  var paLastScroll = 0;
  document.addEventListener('scroll', function (e) {
    try { if (e.target && e.target.closest && e.target.closest('cart-drawer')) paLastScroll = Date.now(); } catch (err) {}
  }, true);

  // Upsell em lista: adicionar produto
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.pa-upsell__add');
    if (!btn) return;
    if (paTouchMoved) return;
    if (Date.now() - paLastScroll < 300) return;
    var row = btn.closest('[data-pa-item]') || btn.closest('.pa-upsell__row');
    var sel = row && row.querySelector('.pa-upsell__select');
    var id = parseInt(sel && sel.value, 10);
    if (!id) return;
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = '…';
    postJSON('/cart/add.js', { items: [{ id: id, quantity: 1 }] })
      .then(refreshDrawer)
      .catch(function () { btn.disabled = false; btn.textContent = label; });
  });

  // Checkout: remove o brinde (o Yampi aplica o brinde dele na etapa seguinte)
  window.paCheckout = function () {
    var el = document.querySelector('cart-drawer');
    var v = el ? parseInt(el.dataset.paGiftVariant, 10) : 0;
    var strip = el ? el.dataset.paGiftStrip === 'true' : false;
    var go = function () {
      if (typeof window.yampiClick === 'function') { window.yampiClick(); }
      else { window.location.href = '/checkout'; }
    };
    if (!v || !strip) { go(); return; }
    busy = true; // segura o reconcile pra não readicionar o brinde durante o checkout
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var gift = cart.items.filter(function (i) { return i.variant_id === v; })[0];
        if (!gift) { go(); return; }
        return postJSON('/cart/change.js', { id: gift.key, quantity: 0 }).then(go, go);
      })
      .catch(go);
  };

  // Upsell: troca a foto ao mudar a variante
  document.addEventListener('change', function (e) {
    var sel = e.target;
    if (!sel.classList || !sel.classList.contains('pa-upsell__select') || sel.tagName !== 'SELECT') return;
    var opt = sel.options[sel.selectedIndex];
    var img = opt && opt.getAttribute('data-img');
    if (!img) return;
    var item = sel.closest('[data-pa-item]');
    var el = item && item.querySelector('img');
    if (el) el.src = img;
  });

  // Carrossel de upsell: setas + dots
  document.addEventListener('click', function (e) {
    var nav = e.target.closest('.pa-uc__nav');
    if (!nav) return;
    var track = nav.closest('.pa-uc').querySelector('.pa-uc__track');
    var w = track.clientWidth;
    track.scrollBy({ left: nav.classList.contains('pa-uc__prev') ? -w : w, behavior: 'smooth' });
  });
  document.addEventListener('scroll', function (e) {
    var track = e.target;
    if (!track.classList || !track.classList.contains('pa-uc__track')) return;
    var i = Math.round(track.scrollLeft / track.clientWidth);
    var dots = track.closest('.pa-uc').querySelectorAll('.pa-uc__dot');
    dots.forEach(function (d, di) { d.classList.toggle('is-active', di === i); });
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
})();

/* Livéa: upsell com 2 selects (Farbe + Größe) — resolve a variante e troca foto/botão */
(function () {
  document.addEventListener('change', function (e) {
    var sel = e.target;
    if (!sel.classList || !sel.classList.contains('pa-upsell__opt')) return;
    var wrap = sel.closest('[data-pa-opts]');
    if (!wrap) return;
    var opts = wrap.querySelectorAll('.pa-upsell__opt');
    var o1 = opts[0] ? opts[0].value : null;
    var o2 = opts[1] ? opts[1].value : null;
    var vEl = wrap.querySelector('[data-pa-variants]');
    var hidden = wrap.querySelector('.pa-upsell__select');
    if (!vEl || !hidden) return;
    var vars;
    try { vars = JSON.parse(vEl.textContent); } catch (err) { return; }
    var v = null;
    for (var i = 0; i < vars.length; i++) {
      if (vars[i].o1 === o1 && (o2 === null || vars[i].o2 === o2)) { v = vars[i]; break; }
    }
    var item = sel.closest('[data-pa-item]');
    var btn = item && item.querySelector('.pa-upsell__add');
    if (v && v.a) {
      hidden.value = v.id;
      if (btn) btn.disabled = false;
      if (v.img && item) { var img = item.querySelector('img'); if (img) img.src = v.img; }
    } else {
      hidden.value = '';
      if (btn) btn.disabled = true;
    }
  });
})();
